<div class="row justify-content-center">
  <div class="col-auto">
    <div class="section-header mb-4 d-flex text-center justify-content-center gap-2" style="max-width: 520px;">
      <span class="material-symbols-outlined">admin_panel_settings</span>
      <h1 class="h4">Directores de <strong class="fw-semibold text-colonial">banco</strong></h1>
    </div>
    <p class="text-muted mx-auto text-center" style="max-width: 520px;">Invita usuarios globales y regionales.
      Obtienen acceso al iniciar sesión con el correo invitado.</p>
  </div>
</div>

<div class="row justify-content-center">
  <div class="col-12 col-xl-10">

    <div class="card shadow-sm mb-3 rounded-4 overflow-hidden">
      <div class="card-header bg-white py-3 d-flex align-items-center justify-content-between">
        <h3 class="h5 d-flex gap-2 mb-0 align-items-center">
          <span class="material-symbols-outlined text-colonial">filter_list</span>
          <span>Filtros</span>
        </h3>
        <button class="btn btn-secondary bg-colonial d-flex align-items-center gap-2" type="button"
          (click)="openInviteModal()">
          <span class="material-symbols-outlined" style="font-size: 18px;">person_add</span>
          Invitar usuario
        </button>
      </div>
      <div class="card-body">
        <div class="row g-3 align-items-end">
          <div class="col-12 col-md-4">
            <label class="form-label">Rol</label>
            <select class="form-select" [(ngModel)]="roleFilter" (change)="refresh()">
              <option value="">Todos</option>
              <option value="Global">Global</option>
              <option value="Regional">Regional</option>
            </select>
          </div>
          <div class="col-12 col-md-4">
            <label class="form-label">Estado</label>
            <select class="form-select" [(ngModel)]="statusFilter" (change)="refresh()">
              <option value="">Todos</option>
              <option value="Active">Activo</option>
              <option value="Inactive">Inactivo</option>
            </select>
          </div>
        </div>
      </div>
    </div>

    <div class="card shadow-sm border-0 overflow-hidden rounded-4">
      <shared-table-container>
        <shared-table [headers]="tableHeaders" [items]="directors" noItemsTitle="Sin administradores">
          <ng-template let-role="role" sharedTableColumn="role">
            <span>{{ displayRole(role) }}</span>
          </ng-template>
          <ng-template let-id="id" sharedTableColumn="regions">
            <ng-container *ngFor="let d of directors">
              <span *ngIf="d.id === id">{{ displayRegions(d) }}</span>
            </ng-container>
          </ng-template>
          <ng-template let-isLinked="isLinked" sharedTableColumn="isLinked">
            <span class="badge" [class.text-bg-success]="isLinked" [class.text-bg-warning]="!isLinked">
              {{ isLinked ? 'Vinculado' : 'Invitación pendiente' }}
            </span>
          </ng-template>
          <ng-template let-id="id" let-isActive="isActive" sharedTableColumn="isActive">
            <button (click)="$event.stopPropagation(); openStatusModal(id)"
              class="btn btn-sm btn-outline-secondary" type="button">
              {{ isActive ? 'Activo' : 'Inactivo' }}
            </button>
          </ng-template>
          <ng-template let-id="id" let-role="role" let-isLinked="isLinked" sharedTableColumn="actions">
            <div class="d-flex gap-2">
              <button *ngIf="role === 'Regional'" (click)="$event.stopPropagation(); openRegionsModal(id)"
                class="btn btn-sm btn-outline-secondary" type="button" title="Editar regiones">
                <span class="material-symbols-outlined" style="font-size: 18px;">map</span>
              </button>
              <button *ngIf="!isLinked" (click)="$event.stopPropagation(); resendInvite(id)"
                class="btn btn-sm btn-outline-secondary" type="button" title="Reenviar invitación">
                <span class="material-symbols-outlined" style="font-size: 18px;">forward_to_inbox</span>
              </button>
              <button *ngIf="!isLinked" (click)="$event.stopPropagation(); deleteInvite(id)"
                class="btn btn-sm btn-outline-danger" type="button" title="Eliminar invitación">
                <span class="material-symbols-outlined" style="font-size: 18px;">delete</span>
              </button>
            </div>
          </ng-template>
        </shared-table>
      </shared-table-container>
    </div>

  </div>
</div>

<app-director-invite-modal *ngIf="showInviteModal" [editingRegionsFor]="editingRegionsFor"
  (closed)="onInviteModalClosed($event)"></app-director-invite-modal>

<app-status-change-modal *ngIf="statusChange" [options]="statusOptions" [currentStatus]="statusChange.current"
  (closed)="onStatusModalClosed($event)"></app-status-change-modal>
